export enum UseRole {
  SuperAdmin = 'super_admin',
  Owner = 'owner',
  Admin = 'admin',
  Manager = 'manager',
}

export enum UserPermission {
  DocumentsEdit = 'documents_edit',
  DocumentsView = 'documents_view',
  DocumentsInternal = 'documents_internal',
  FeatureFlagsEdit = 'feature_flags_edit',
  FeatureFlagsView = 'feature_flags_view',
  FeatureFlagsDelete = 'feature_flags_delete',
  FeatureFlagsCreate = 'feature_flags_create',
  MarketEdit = 'market_edit',
  MarketView = 'market_view',
  MarketDelete = 'market_delete',
  MarketCreate = 'market_create',
  OnboardingEdit = 'onboarding_edit',
  OnboardingView = 'onboarding_view',
  OnboardingCreate = 'onboarding_create',
  OnboardingRecollect = 'onboarding_recollect',
  OnboardingInternal = 'onboarding_internal',
  OnboardingDownloadCsv = 'onboarding_download_csv',
  PartnerEdit = 'partner_edit',
  PartnerView = 'partner_view',
  PartnerGigsafeConfigEdit = 'partner_gigsafe_config_edit',
  PartnerGigsafeConfigView = 'partner_gigsafe_config_view',
  PartnerProductsEdit = 'partner_products_edit',
  PartnerProductsView = 'partner_products_view',
  PartnerProductsDelete = 'partner_products_delete',
  PartnerProductsCreate = 'partner_products_create',
  PartnerDriversImport = 'partner_drivers_import',
  PartnerDriversEdit = 'partner_drivers_edit',
  PartnerDriversView = 'partner_drivers_view',
  PaymentsEdit = 'payments_edit',
  PaymentsView = 'payments_view',
  PaymentsDelete = 'payments_delete',
  PaymentsCreate = 'payments_create',
  PaymentsProcess = 'payments_process',
  PaymentsDownloadInvoices = 'payments_download_invoices',
  PaymentsCreateBuyer = 'payments_create_buyer',
  TemplatesEdit = 'templates_edit',
  TemplatesView = 'templates_view',
  TemplatesDelete = 'templates_delete',
  TemplatesCreate = 'templates_create',
  UsersEdit = 'users_edit',
  UsersView = 'users_view',
  UsersCreate = 'users_create',
  LoginAs = 'login_as',
  InvitesView = 'invites_view',
  InvitesCreate = 'invites_create',
  RolesView = 'roles_view',
  RolesEdit = 'roles_edit',
  OnboardingReview = 'onboarding_review',
  InvitesEdit = 'invites_edit',
  RolesDelete = 'roles_delete',
  AccessUpdate = 'access_update',
  ContractorView = 'contractor_view',
  PersonallyIdentifiableInformationView = 'personally_identifiable_information_view',

  // Manipulations with Master Contractors from Customer side - invite, activate, deactivate
  CustomerMasterContractorEdit = 'customer_master_contractor_edit',
  CustomerMasterContractorView = 'customer_master_contractor_view',
  CustomerMasterContractorDelete = 'customer_master_contractor_delete',
  CustomerMasterContractorCreate = 'customer_master_contractor_create',

  // Customer accepts/declines/assigns market for Subcontractors assigned by Master Contractors
  SubcontractorEdit = 'subcontractor_edit',
  SubcontractorView = 'subcontractor_view',
  SubcontractorDelete = 'subcontractor_delete',

  // Manipulations with Customers from Master Contractor side - accept invites, reject invites, deactivate relations
  MasterContractorCustomerEdit = 'master_contractor_customer_edit',
  MasterContractorCustomerView = 'master_contractor_customer_view',
  MasterContractorCustomerDelete = 'master_contractor_customer_delete',

  // Master Contractor assings/unassigns drivers to/from customers
  MasterContractorCustomerSubcontractorEdit = 'master_contractor_customer_subcontractor_edit',
  MasterContractorCustomerSubcontractorView = 'master_contractor_customer_subcontractor_view',
  MasterContractorCustomerSubcontractorDelete = 'master_contractor_customer_subcontractor_delete',

  // McLite
  McLiteEdit = 'mc_lite_edit',
  McLiteView = 'mc_lite_view',
  McLiteDelete = 'mc_lite_delete',

  // contractor notes
  ContractorNotesView = 'contractor_notes_view',
  ContractorNotesCreate = 'contractor_notes_create',
  ContractorNotesEdit = 'contractor_notes_edit',

  // contractor files
  ContractorFilesView = 'contractor_files_view',
  ContractorFilesCreate = 'contractor_files_create',
  ContractorFilesEdit = 'contractor_files_edit',
  ContractorFilesDelete = 'contractor_files_delete',

  // customer rejection reasons
  CustomerReviewRejectionReasonView = 'customer_review_rejection_reason_view',
  CustomerReviewRejectionReasonEdit = 'customer_review_rejection_reason_edit',
  CustomerReviewRejectionReasonDelete = 'customer_review_rejection_reason_delete',
}

export enum UserProductName {
  GigSafe = 'gigsafe',
  Payments = 'payments',
  CXTIntegration = 'cxt_integration',
  Subcontractor = 'subcontractor',
  McLite = 'mclite',
}

export enum UserNotificationPeriod {
  Instant = 'instant',
  Hourly = 'hourly',
  Daily = 'daily',
}
